// extracted by mini-css-extract-plugin
export default {"to__top":"page_to__top__GGB6J","not__found_wrapper":"page_not__found_wrapper__x7PeK","not__found":"page_not__found__BM7LR"};